import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";

export default function MapFab(props: {
  children: React.ReactNode;
  badge?: number;
  onClick: React.MouseEventHandler<HTMLElement>;
}) {
  return (
    <Root onClick={props.onClick}>
      {props.children}
      {props.badge !== undefined && props.badge > 0 && <Badge>{props.badge}</Badge>}
    </Root>
  );
}

const pulsingKeyframes = keyframes`
  from {
      transform: scale(1);
      opacity: 1;
  }
  to {
    transform: scale(1.5);
    opacity: 0;
  }
`;

const Root = styled(motion.button)<{ colorScheme?: "light" | "red"; pulsing?: boolean }>`
  --bg-color: white;
  --text-color: black;
  background-color: var(--bg-color);
  box-shadow: 0 0 4px -1px;
  color: var(--text-color);
  border: transparent;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  transition: all 0.1s ease;
  position: relative;

  svg {
    font-size: 24px;
  }

  ${({ pulsing }) => {
    if (pulsing !== true) {
      return css``;
    }

    return css`
      &:before {
        background-color: var(--text-color);
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 24px;
        animation: ${pulsingKeyframes} 1.5s ease infinite;
        z-index: -1;
      }
    `;
  }}

  &:active {
    scale: 0.95;
  }

  ${({ colorScheme }) => {
    switch (colorScheme) {
      case undefined:
      case "light":
        return css`
          --bg-color: white;
          --text-color: var(--tw-slate-500);
        `;
      case "red":
        return css`
          --bg-color: var(--tw-red-50);
          --text-color: var(--tw-red-500);
        `;
    }
  }}
`;

const Badge = styled.div`
  background-color: var(--tw-red-500);
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  color: white;
  line-height: 12px;
  padding: 2px 4px;
  border-radius: 32px;
  min-width: 20px;
  box-sizing: border-box;
  transform: translate(75%, -75%);
  border: 2px solid var(--tw-slate-50);
`;
